import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { match } from 'ts-pattern';
import Text from '../text';
import Badge from '../badge';
import classnames from 'classnames/bind';
import { ColorNames } from '../../../constants/colorVars';
import PopupTooltip from '../../overlays/popupTooltip';
import Icon from '../icon';
import { getCssColorFromColorName, lightenColor } from '../../../utils/colors';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const StatusMessage = ({ className, elmId = 'status-message', color: colorName = ColorNames.Gray, style, title, description, badgeText, badgeLabel, tooltipText, }) => {
    const backgroundColor = match(colorName)
        .with(ColorNames.Gray, () => ColorNames.GrayExtraLight)
        .with(ColorNames.Info, () => ColorNames.InfoExtraLight)
        .with(ColorNames.Success, () => ColorNames.SuccessExtraLight)
        .with(ColorNames.Caution, () => ColorNames.CautionExtraLight)
        .with(ColorNames.Error, () => ColorNames.ErrorExtraLight)
        .with(ColorNames.Purple, () => ColorNames.PurpleExtraLight)
        .exhaustive();
    const rawForegroundColor = getCssColorFromColorName(colorName);
    const rawBackgroundColor = getCssColorFromColorName(backgroundColor);
    const rawBorderColor = lightenColor(rawForegroundColor, 70);
    return (_jsxs("div", { className: cx('status-message', className), "data-elm-id": elmId, style: {
            backgroundColor: rawBackgroundColor,
            borderColor: rawBorderColor,
            ...style,
        }, children: [_jsxs("div", { className: cx('left'), "data-elm-id": `${elmId}-left`, children: [_jsxs("div", { className: cx('tooltip-icon'), children: [_jsx(Text, { size: 'tiny', weight: 'heavy', color: colorName, children: title }), tooltipText && (_jsx(PopupTooltip, { on: 'hover', trigger: _jsx(Icon, { name: 'info-circle', iconStyle: 'light', color: 'gray', size: 'small' }), children: tooltipText }))] }), _jsx(Text, { size: 'tiny', color: ColorNames.Gray, children: description })] }), _jsxs("div", { className: cx('right'), "data-elm-id": `${elmId}-right`, children: [_jsx(Text, { size: 'tiny', color: ColorNames.Gray, children: badgeLabel }), badgeText && (_jsx(Badge, { className: cx('badge'), primary: badgeText, secondary: '', mode: colorName, size: 'small' }))] })] }));
};
export default StatusMessage;
//# sourceMappingURL=index.js.map